export const RANDOMIZER_ERROR_CODES = [
    'randomizer_exhausted',
    'randomizer_no_outfit',
] as const;

export const isRandomizerError = (code?: string): boolean =>
    RANDOMIZER_ERROR_CODES.includes(
        code as (typeof RANDOMIZER_ERROR_CODES)[number],
    );
